import React from "react"

import { useAppSelector } from "../../../../hooks"

import { formatString } from "../../../../util/Strings"
import { Labels } from "../../../../util/Translations"

const PageFooter: React.FC = () => {
    const footerData = useAppSelector((state) => state.itemDetail.pageFooter)
    const [createdOn, setCreatedOn] = React.useState<React.ReactNode | string>(
        "",
    )
    const [lastModifiedOn, setLastModifiedOn] = React.useState<
        React.ReactNode | string
    >("")

    const { Unknown, FooterAtBy } = Labels

    React.useEffect(() => {
        if (!footerData || !footerData.createdOn) {
            setCreatedOn("")
            setLastModifiedOn("")
            return
        }
        const createdOn = (
            <span>
                {formatString(
                    FooterAtBy,
                    footerData?.createdOn?.label || "",
                    footerData?.createdOn?.date || "",
                    footerData?.createdOn?.time || "",
                    footerData?.createdBy?.user.label || "",
                )}
                {footerData?.createdOnBehalfOf?.user.label && (
                    <span>
                        {`${footerData?.createdOnBehalfOf?.label} ${
                            footerData?.createdOnBehalfOf?.user.label || Unknown
                        }`}
                    </span>
                )}
            </span>
        )

        setCreatedOn(createdOn)

        const lastModifiedOn = (
            <span>
                {formatString(
                    FooterAtBy,
                    footerData?.lastModifiedOn?.label || "",
                    footerData?.lastModifiedOn?.date || "",
                    footerData?.lastModifiedOn?.time || "",
                    footerData?.lastModifiedBy?.user.label || "",
                )}
                {footerData?.modifiedOnBehalfOf?.user.label && (
                    <span>
                        {`${footerData?.modifiedOnBehalfOf?.label} ${
                            footerData?.modifiedOnBehalfOf?.user.label ||
                            Unknown
                        }`}
                    </span>
                )}
            </span>
        )

        setLastModifiedOn(lastModifiedOn)
    }, [footerData])

    return (
        <div className="tid-footer-wrapper">
            <div className="tid-footer">
                <div className="grid-field">
                    <div className="label" data-ft-field-label="Created on">
                        {createdOn}
                    </div>

                    <div className="label" data-ft-field-label="Last update">
                        {lastModifiedOn}
                    </div>
                </div>
            </div>
            <div className="tid-branching"></div>
        </div>
    )
}
export default PageFooter
